export default __webpack_public_path__ + "377beeb80cc76cf140b33d0115eb4a2f.png";